<!--<div style="overflow: hidden" id="frm_add_or_edit">-->
<!--  <div class="row">-->
<!--    &lt;!&ndash; sidebar left - Thông tin chung &ndash;&gt;-->
<!--    <div class="col-lg-5 col-md-12 col-sm-12 pr-0">-->
<!--      <div class="card"-->
<!--        style="height: calc(91vh - 140px); overflow-y: scroll; border-radius: 0px !important; padding-bottom: 50px; border: none;">-->
<!--        <app-general-form-info [maxSize]="maxSize"></app-general-form-info>-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash; sidebar right, thông tin luồng ký &ndash;&gt;-->
<!--    <div class="col-lg-7 col-md-12 col-sm-12 pl-0" style="padding-right: 0.75rem;">-->
<!--      <div class="card"-->
<!--        style="height: calc(91vh - 140px); overflow-y: scroll; border-radius: 0px !important; padding-bottom: 50px; border: none;">-->
<!--        <app-record-party-sign></app-record-party-sign>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<div class="row" style="overflow-y: auto">
  <div class="col-12"><app-general-form-info [check]="1" [maxSize]="maxSize"></app-general-form-info></div>
  <div class="col-12"><app-record-party-sign [check]="1"></app-record-party-sign></div>
  <div class="col-12" style="padding-right: 12px"><app-general-form-info [check]="2" [maxSize]="maxSize"></app-general-form-info></div>
</div>

